/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/exclamation-mark-2194196': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 14a1 1 0 001-1V7a1 1 0 00-2 0v6a1 1 0 001 1zm0 4a1.25 1.25 0 10-1.25-1.25A1.25 1.25 0 0012 18z"/>'
  }
})
